import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
export default function logs() {
  return (
      <>        
          <div className="home">
              <Sidebar />
              <div className="homeContainer">
                  <Navbar />
                  <div className="text-center"><h1>All Logs</h1></div>
              </div>
          </div>

          
      </>
  )
}